module.exports = __webpack_public_path__ + "img/icon_function@2x.50061238.png";